export default "/institutions/bradesco.svg";